import type { Locale } from './types';

export const DEFAULT_LOCALE: Locale = 'en';
export const LOCALES: Array<Locale> = ['en', 'pt-BR', 'es-ES', 'de-DE'];
export const PATH_LOCALES = ['en-US', 'pt-BR', 'es-ES', 'de-DE'];
export const DEFAULT_PATH_LOCALE = 'en-US';
/**
 * The locales that are released to the public in parts of the application thats not yet translated.
 * These locales are the ones that are available in the language selector.
 */
export const RELEASED_LOCALES: Array<Locale> = ['en', 'de-DE'];
export const USER_LOCALE_STORAGE_KEY = 'mm-user-locale';
export const LANGUAGE_SELECTOR_OPTIONS = {
  'en-US': 'English',
  'de-DE': 'German',
  'pt-BR': 'Portuguese (Brazil)',
  'es-ES': 'Spanish',
} as const;
